import type {SupplierList} from "../../../types/suppliers.types";

import {deleteSupplier} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../supplier-keys";

export function deleteSupplierMutationOptions() {
  const listFilter = {queryKey: supplierKeys.lists()};

  return mutationOptions({
    mutationKey: supplierMutationKeys.deleteSupplier,
    mutationFn: (id: string) => deleteSupplier(id),
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<SupplierList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];

        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.supplierId === deletedId)
        ) {
          continue;
        }

        client.setQueryData<SupplierList>(key, {
          ...list,
          items: list.items.filter((item) => item.supplierId !== deletedId),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? []) {
        client.setQueryData(key, snapshot);
      }
    },
    onSuccess: async (_data, id, _context, {client}) => {
      client.removeQueries({queryKey: supplierKeys.detail(id)});
      await client.invalidateQueries(listFilter);
    },
  });
}
